module.exports = __webpack_public_path__ + "img/img12.3efb1488.svg";